import { render, staticRenderFns } from "./Recommendation.About.vue?vue&type=template&id=b9f77e44&scoped=true&"
import script from "./Recommendation.About.vue?vue&type=script&lang=js&"
export * from "./Recommendation.About.vue?vue&type=script&lang=js&"
import style0 from "./Recommendation.About.vue?vue&type=style&index=0&id=b9f77e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f77e44",
  null
  
)

export default component.exports